/**
 * InvoiceDialog - Dialog to create invoice for pending charges
 * Extracted from CustomersPage.js
 */
import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { formatCHF } from '../../../utils/format';

const InvoiceDialog = ({
  open,
  onOpenChange,
  pendingCharges,
  onGenerateInvoice,
  generating = false
}) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Rechnung erstellen</DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          <p>Möchten Sie jetzt eine Rechnung für alle offenen Trainings erstellen?</p>
          {pendingCharges && (
            <div className="bg-gray-50 p-4 rounded-lg">
              <p><strong>Anzahl Trainings:</strong> {pendingCharges.total_count}</p>
              <p><strong>Gesamtbetrag:</strong> CHF {formatCHF(pendingCharges.total_amount)}</p>
            </div>
          )}
        </div>
        <div className="flex justify-end gap-2 mt-4">
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Abbrechen
          </Button>
          <Button onClick={onGenerateInvoice} disabled={generating} data-testid="invoice-dialog-create-btn">
            {generating ? '⏳ Wird erstellt…' : 'Rechnung erstellen'}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default InvoiceDialog;
